import fetch from "../fetch";
import get from "lodash/get";

export default ({ id, values }) => {
  const fundId =
    typeof values.fund_id === "string"
      ? values.fund_id
      : get(values, "fund_id.entity_id");

  return fetch({
    path: id ? `/hy/funds/${id}` : "/hy/funds",
    method: id ? "PUT" : "POST",
    data: {
      ...values,
      fund_id: fundId,
      managers: get(values, "managers", []).map(
        ({ manager_id: { entity_id } }) => entity_id,
      ),
    },
  });
};
